import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: "60%",
    },
    formControl: {
        margin: theme.spacing(2),
        minWidth: 200,
        width: "100%"
    },
    dropdownLabel: {
        backgroundColor: theme.palette.background.default
    },
    errorIcon: {
        color: theme.palette.error.main
    },
    successIcon: {
        color: theme.palette.success.main
    },
    associationLogo: {
        margin: theme.spacing(2)
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        padding: theme.spacing(2)
    },
    row: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    email: {
        color: theme.palette.text.primary,
        fontWeight: "bold",
        fontSize: 18
    },
    lastSignIn: {
        color: theme.palette.text.secondary
    }
}));

export {useStyles};
